"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _leva = require("leva");
var _drei = require("@react-three/drei");
var _reactErrorBoundary = require("react-error-boundary");
var _reactBootstrap = require("react-bootstrap");
var _paulCorePackage = require("paul-core-package");
var _Scene = _interopRequireDefault(require("../../../components/Viewer/Scene"));
var _View3dModule = _interopRequireDefault(require("../../../styles/components/View3d.module.css"));
var _SceneContainer = _interopRequireDefault(require("../../../components/Viewer/SceneContainer"));
var _actions = require("../../../redux/actions");
var _widgets = require("../../../widgets");
var _reducers = require("../../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../../redux/sagas"));
var _constants = require("../../../utils/constants");
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Viewer3dFiberContent = _ref => {
  let {
    canvasClassName
  } = _ref;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_reactRedux.ReactReduxContext.Consumer, null, _ref2 => {
    let {
      store
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_Scene.default, {
      canvasClassName: canvasClassName
    }, /*#__PURE__*/_react.default.createElement(_drei.Bounds, {
      fit: true,
      clip: true,
      observe: true,
      margin: 1.1,
      damping: 3,
      eps: 0.5
    }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
      store: store
    }, /*#__PURE__*/_react.default.createElement(_SceneContainer.default, null))));
  }), [canvasClassName]);
};

/** @todo remove bootstrap components */

/**
 * @class Viewer3dFiberSockets
 *
 * @param {boolean} isDebug
 * @param {boolean} fillSize For panels position
 * @param {string} theme
 * @param {string} width
 * @param {string} height
 * @param {string} backgroundColor
 * @param {string} classNameWrap
 * @param {styles} styleWrap
 * @param {styles} canvasClassName
 *
 * @return {JSX.Element}
 * @constructor
 */

const Viewer3dFiberSockets = _ref3 => {
  let {
    isDebug = false,
    fillSize = false,
    theme = _paulCorePackage.constants.themeKey.light,
    width = '100vw',
    height = '100vh',
    backgroundColor: propBackgroundColor = '',
    classNameWrap = '',
    styleWrap = {},
    canvasClassName
  } = _ref3;
  const backgroundColor = propBackgroundColor || _constants.themeSettings[theme].backgroundColor;
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(() => {
    dispatch((0, _actions.setDebugModeStatus)(isDebug));
  }, [dispatch, isDebug]);
  (0, _react.useEffect)(() => {
    dispatch((0, _actions.setPackageTheme)(theme));
  }, [dispatch, theme]);
  (0, _react.useEffect)(() => () => {
    dispatch((0, _actions.resetAllComponents)());
  }, [dispatch]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: _objectSpread({
      height,
      width,
      backgroundColor,
      position: 'relative'
    }, styleWrap),
    className: "".concat(_View3dModule.default.box, " ").concat(fillSize ? _View3dModule.default.fillSize : '', " ").concat(classNameWrap)
  }, /*#__PURE__*/_react.default.createElement(Viewer3dFiberContent, {
    canvasClassName: canvasClassName
  }), /*#__PURE__*/_react.default.createElement(_leva.Leva, {
    isRoot: true,
    hidden: !isDebug,
    oneLineLabels: true
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: _View3dModule.default.as_nav_container
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_widgets.Filter, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      mt: 5,
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_widgets.CameraPositions, null)))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: "lg",
    className: _View3dModule.default.container
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: _View3dModule.default.select_wrap
  }, /*#__PURE__*/_react.default.createElement(_widgets.SelectAddress, null), /*#__PURE__*/_react.default.createElement(_widgets.SelectPwhC, null), /*#__PURE__*/_react.default.createElement(_widgets.SelectHtgHx, null))))), [height, width, backgroundColor, styleWrap, classNameWrap, isDebug, canvasClassName]);
};

/**
 * @class Viewer3dFiber
 *
 * @param {boolean} props.isDebug
 * @param {string} props.theme
 * @param {string} props.width
 * @param {string} props.height
 * @param {string} props.backgroundColor
 * @param {string} props.classNameWrap
 * @param {styles} props.styleWrap
 * @param {function} props.propGetActiveBuilding
 * @param {function} props.propGetActivePwhC
 *
 * @return {JSX.Element}
 * @constructor
 */

const Viewer3dFiberInitial = props => {
  const dispatch = (0, _reactRedux.useDispatch)();
  const firstEffect = (0, _react.useRef)(true);
  /** @todo add selector to the core */
  const coreDevices = (0, _reactRedux.useSelector)(store => {
    var _store$constants$pack;
    return ((_store$constants$pack = store[_paulCorePackage.constants.packageKey]) === null || _store$constants$pack === void 0 ? void 0 : _store$constants$pack.devices) || {};
  });
  (0, _react.useEffect)(() => {
    if (firstEffect.current && coreDevices !== null && coreDevices !== void 0 && coreDevices.hasData) {
      firstEffect.current = false;
      dispatch((0, _actions.setInitialDeviceData)({
        result: coreDevices
      }));
    }
  }, [dispatch, coreDevices]);
  (0, _react.useEffect)(() => {
    return () => {
      firstEffect.current = true;
    };
  }, []);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(Viewer3dFiberSockets, props), [props]);
};

/** @deprecated Viewer3dFiber */
const Viewer3dFiber = props => {
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      viewer: _reducers.viewer,
      components: _reducers.components
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(Viewer3dFiberInitial, props);
};

/** @deprecated export default*/
var _default = exports.default = (0, _reactErrorBoundary.withErrorBoundary)(Viewer3dFiber, {
  FallbackComponent: () => null,
  onError: (err, info) => console.error(err, info)
});